import React, { useState } from 'react';
import ArchitectureComponentMap from './ArchitectureComponentMap';
import { HbrIcon } from '@harbor/elements-react-standalone';
import { caretRight } from '@harbor/elements/icons';
import StbMarkdown from '../../security-toolbox-ui/StbMarkdown';
import { GtmSolutionUseCase } from '../../../types/go-to-market';
import { Product } from '../../../types/product';


const ArchitectureUseCaseCard: React.FC<{
  useCase: GtmSolutionUseCase,
  productMap: Record<Product['id'], Product>,
  solutionDetailLoading?: boolean,
}> = ({
  useCase,
  productMap,
  solutionDetailLoading = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      key={useCase.id}
      className="relative mb-4 cursor-pointer rounded-xl outline outline-2 outline-gray-10 h-full flex flex-col transition-colors duration-500 hover:outline-cisco-blue-60"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="absolute top-2 right-2 flex items-center text-center gap-[2px]">
        <div className="text-sm font-semibold italic text-orange-50 transition-colors duration-300">
          {isExpanded ? 'Close' : 'View'}
        </div>
        <HbrIcon
          asset={caretRight}
          className={`${isExpanded ? 'rotate-90': ''} text-orange-50 transition-all duration-500`}
        />
      </div>

      <div className="px-4 mb-4">
        <div className="flex flex-row justify-between items-center mb-2">
          <h3 className="text-lg font-bold mb-2 text-cisco-blue-60">{useCase?.name}</h3>
        </div>
        <div>{useCase?.description 
          ? <StbMarkdown>{useCase.description}</StbMarkdown>
          : (<div className="italic text-gray-50">No description provided.</div>)}
        </div>
      </div>

      <div
        className={`grid min-h-0 transition-[opacity,grid-template-rows] duration-500 overflow-hidden ${isExpanded ? 'opacity-100' : 'opacity-0'}`}
        style={{ gridTemplateRows: isExpanded ? '1fr' : '0fr' }}
      >
        <div className="grid min-h-0 gap-4">
          <div id="architecture-usecase-component-map">
            {useCase
              ? (
                  <ArchitectureComponentMap
                    components={useCase?.components ?? []}
                    productMapMaster={productMap}
                    solutionDetailLoading={solutionDetailLoading}
                    bgColor="bg-[#f8f8f8]"
                    columnSpan={[2, 3]}
                  />
                )
              : (
                  <div className="italic text-gray-50">Usecase not found.</div>
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArchitectureUseCaseCard;